import { render, staticRenderFns } from "./Lgx279918173887660032.vue?vue&type=template&id=afcb533c&"
import script from "./Lgx279918173887660032.vue?vue&type=script&lang=js&"
export * from "./Lgx279918173887660032.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports